// extracted by mini-css-extract-plugin
export var boxItems = "_1v-1";
export var boxItemsLg = "_1v-2";
export var button = "_1v-7";
export var buttonHoverless = "_1v-9";
export var buttonLg = "_1v-8";
export var filterGroupBox = "_1v-0";
export var icon = "_1v-3";
export var iconSecondary = "_1v-6";
export var iconWrapper = "_1v-4";
export var iconWrapperLg = "_1v-5";
export var truncatedLabel = "_1v-a";